$(document).ready(function(){


$(".button-primary").click(function(){

  setTimeout(function () {
 // alert('hii');
  jQuery.getJSON('/cart.js', function(cart) { 
    
// console.log(cart);
    var remainprice = free_shipping - parseFloat(cart.total_price/ 100);
    //console.log(remainprice);

    $('.remaining_value').text(remainprice.toFixed(2)+' €');
    if(cart.item_count > 0){
    var totalprice = parseInt(cart.total_price);
    //console.log(totalprice/ 100 | 0);
    var totalprice = totalprice / 100 | 0;
    if(totalprice < free_shipping ){
    
      //console.log(totalprice);
      $('#popup').bPopup();
    
    }

  }

   
  });

     }, 1000);

  });


  jQuery.getJSON('/cart.js', function(cart) { 
    
//console.log(cart.total_price);
    var remainprice = free_shipping - parseFloat(cart.total_price/ 100);
    //console.log(remainprice);

    $('.remaining_value').text(remainprice.toFixed(2)+' €');
    if(cart.item_count > 0){
    var totalprice = parseInt(cart.total_price);
    //console.log(totalprice/ 100 | 0);
    var totalprice = totalprice / 100 | 0;
    if(totalprice < free_shipping ){
    
      //console.log(totalprice);
      $('#popup').bPopup();
    
    }

  }
  });
  
});

// function getFormData($form){
//     var unindexed_array = $form.serializeArray();
//     var indexed_array = {};

//     $.map(unindexed_array, function(n, i){
//         indexed_array[n['name']] = n['value'];
//     });

//     return indexed_array;
// }